// Tiny synchronous event emitter — listener-error safe.

export type Listener<T> = (event: T) => void;

export class Emitter<T> {
  private readonly listeners = new Set<Listener<T>>();

  on(listener: Listener<T>): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  emit(event: T): void {
    for (const listener of this.listeners) {
      try {
        listener(event);
      } catch (err) {
        console.error('[emitter] listener threw', err);
      }
    }
  }

  clear(): void {
    this.listeners.clear();
  }
}
